import React, { useState, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import ExpandIcon from '../../assets/images/Expand Arrow1.png';
import InflowIcon from '../../assets/images/reply-arrow.png';
import OutflowIcon from '../../assets/images/forward-arrow.png';
import { PiArrowSquareDownLeftFill } from "react-icons/pi";
import { PiArrowSquareUpRightFill } from "react-icons/pi";
import moment from "moment-timezone";

import { getTransferService , getTransferFromBetweenService , getTransferToBetweenService } from "../../services/transfer.service";

const TransferData = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [transferData, setTransferData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [transferDataTemp, setTransferDataTemp] = useState([]);
    const [startDate, setStartDate] = useState(
        new Date(new Date().setDate(new Date().getDate() - 11)).toISOString().split('T')[0]
    );
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [showDatePicker, setShowDatePicker] = useState(false);
    let lastDate = null;
    let isFrom = true;

    const dispatch = useDispatch();
    moment.locale('en'); // Ensure the language is set to English


    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        getTransferDataOnLoad(signal);

        return () => {
            controller.abort();
        }
    },[]);

    
    useEffect(() => {
        if(searchTerm) {
            const timer = setTimeout(() => {
                const filteredData = transferData.filter((data) =>
                    data.agentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    data.username.toLowerCase().includes(searchTerm.toLowerCase())
                );
                setFilteredData(filteredData);
            }, 350);

            return () => clearTimeout(timer);
        }
        else {
            const sortedData = [...transferData].sort((a, b) => a.remain - b.remain);
            setFilteredData(sortedData);
        }
    }, [searchTerm]);
    

    const getTransferData = async (startDate, endDate,  signal) => {

        dispatch(setIsLoading(true))
        try {
            if(startDate && endDate) {

                const resultInward = await getTransferFromBetweenService(startDate, endDate, 'inward', signal);

                let processedInwardData = [];
                let processedOutwardData = [];

                if (resultInward.data) {
                    processedInwardData = resultInward.data.map(item => ({
                        ...item,
                        amount: Math.abs(item.amount),
                        type: 'inward',
                    }));
                }

                const resultOutward = await getTransferToBetweenService(startDate, endDate, 'outward', signal);
                if (resultOutward.data) {
                    processedOutwardData = resultOutward.data.map(item => ({
                        ...item,
                        amount: -Math.abs(item.amount),
                        type: 'outward',
                    }));
                }

                const combinedData = [...processedInwardData, ...processedOutwardData];
                const sortedData = combinedData.sort((a, b) =>
                    new Date(b.transferDate.value) - new Date(a.transferDate.value)
                );
                setTransferData(sortedData);
                setFilteredData(sortedData);

            }
            else {
                //nothing
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
        dispatch(setIsLoading(false))
        }
    }

    const getTransferDataOnLoad = async () => {
        const controller = new AbortController();
        const signal = controller.signal;
        setStartDate(new Date(new Date().setDate(new Date().getDate() - 11)).toISOString().split('T')[0])
        setEndDate(new Date().toISOString().split('T')[0])

        getTransferData(startDate, endDate, signal);

        return () => {
            controller.abort();
        }
    }

    const handleBetweenDate = async () => {
        const controller = new AbortController();
        const signal = controller.signal;

        getTransferData(startDate, endDate, signal);

        return () => {
            controller.abort();
        }
    }

    // const handleFromDate = () => {
    //     isFrom = true;
    //     handleBetweenDate('inward');
    // }

    // const handleToDate = () => {
    //     isFrom = false;
    //     handleBetweenDate('outward');
    // }

    const handleShowPicker = () => {
        setShowDatePicker(!showDatePicker);
    }

    const datePickerPanel = () => {
        return (
            <div className='flex justify-between items-center gap-2 w-[90%] px-2 text-sm h-32 mb-5 mx-auto border-y-2 border-green'>
                <div>
                    Search: <br /><br />
                    <input 
                        type="text" 
                        placeholder="Search..." 
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-[180px] h-[30px] border-2 border-gray-300 rounded-md px-2 py-1 outline-none" 
                    />
                    
                </div>
                <div className='flex flex-col justify-center items-center gap-2'>
                    <div className='w-[100%] h-[100%]'>
                        <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className='w-[100%] h-[100%] border-2 border-gray-300 rounded-md px-2 py-1 outline-none' />
                    </div>
                    <div className='w-[100%] h-[100%]'>
                        <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className='w-[100%] h-[100%] border-2 border-gray-300 rounded-md px-2 py-1 outline-none' />
                    </div>
                    <button onClick={() => handleBetweenDate()} className='w-[100%] h-[100%] bg-primary text-white rounded-md px-5 py-1.5'>
                        Find
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div>
            <div className='bg-white rounded-sm h-[87vh] mx-2 my-2'>
                <div className='w-[100%] h-[90%]'>
                    <div className='flex justify-between w-[90%] pt-6 pb-4 mx-auto'>
                        <h1 className='text-xl ml-2 text-textcol font-bold'>Transfer History </h1>

                        <div className='flex gap-4 cursor-pointer select-none'>
                            {/*
                                <div>
                                    <PiArrowSquareDownLeftFill size={28} color='green'  onClick={() => handleFromDate()} />
                                </div>
                                <div className='mr-1'>
                                    <PiArrowSquareUpRightFill size={28} color='red' onClick={() => handleToDate()} />
                                </div>
                             */}
                            <div>
                                <img src={ExpandIcon} alt="" className='w-8 h-8 cursor-pointer' onClick={handleShowPicker} />
                            </div>
                        </div>
                    </div>


                    {showDatePicker && datePickerPanel()}

                    <div className="w-[92%] h-[95%] text-sm mx-auto  overflow-y-auto select-none">

                        {   filteredData.length > 0 ?
                            <table className='w-full md:w-[100%] mx-auto text-textcol'>

                            <tbody>
                                {filteredData.map((transfer, idx) => {
                                    // const currentDate = transfer.transferDate?.value
                                    // ? moment(transfer.transferDate.value, moment.ISO_8601, true)
                                    //     .tz('Asia/Yangon')
                                    //     .isValid()
                                    //     ? moment(transfer.transferDate.value)
                                    //         .tz('Asia/Yangon')
                                    //         .format("DD/MM/YYYY")
                                    //     : "Invalid Date"
                                    // : "Invalid Date";
                                    const currentDate = transfer.transferDate?.value
                                    ?     moment.utc(transfer.transferDate.value).tz("Asia/Yangon").format('DD-MM-YYYY')
                                    : "Invalid Date";
                                    const currentTime =  moment.utc(transfer.transferDate.value).tz("Asia/Yangon").format('h:mm A')


                                    // Compare with the previous date
                                    const previousDate = idx > 0
                                        ? moment.utc(transferData[idx - 1].transferDate?.value)
                                        .tz('Asia/Yangon')
                                        .format("DD/MM/YYYY")
                                        : null;

                                    const isNewDate = currentDate !== previousDate;

                                    return (
                                    <React.Fragment key={idx}>
                                    {isNewDate && (
                                        <tr>
                                        {/* <td colSpan="100%" className="pl-3 text-slate-400 font-bold py-2">
                                            {currentDate}
                                        </td> */}
                                        </tr>
                                    )}
                                    <tr className="w-full">
                                        <td className="px-3 md:px-5 h-16 flex w-full mb-3">
                                        <div
                                            className={`w-1 h-full mr-1 ${
                                            transfer.type === "inward" ? "bg-emerald-500" : "bg-red"
                                            }`}
                                        ></div>
                                        <div className={`bg-gradient-to-r ${
                                            transfer.type === "inward" ? "from-emerald-50" : "from-pink-50"
                                            } via-slate-50 to-slate-50 w-full px-3 flex justify-between items-center gap-2`}>
                                            <div className="flex flex-col">
                                            <div className="mb-1 text-base font-semibold">
                                                {transfer.type === "inward" ? (
                                                <div>
                                                    <span className="mr-2">{String(transfer.agentName)}</span>
                                                    <span className='text-xs'>♠</span>
                                                    <span className="ml-2">{String(transfer.username)}</span>
                                                </div>
                                                ) : (
                                                <div>
                                                    <span className="mr-2">{String(transfer.username)}</span>
                                                    <span className='text-xs'>♠</span>
                                                    <span className="ml-2">{String(transfer.agentName)}</span>
                                                </div>
                                                )}
                                            </div>
                                            <div className="text-xs text-slate-500">
                                                {currentDate} _ {currentTime}
                                            </div>
                                            </div>

                                            <div className="flex flex-col text-right">
                                            <div className="text-slate-500 mb-1">
                                                {String(transfer.transactionType)}
                                            </div>
                                            <div className={`text-sm font-semibold`}>
                                                {/* ${transfer.type === "inward" ? "text-emerald-500" : "text-red"} */}
                                                {Number(transfer.amount).toLocaleString()}
                                            </div>
                                            </div>
                                        </div>
                                        </td>
                                    </tr>
                                    </React.Fragment>
                                );
                                })}
                            </tbody>
                        </table>
                    :
                        <div className='w-full h-full flex items-center justify-center font-semibold'>
                            <h1 className='text-lg'>No Data To Show</h1>
                        </div>
                    }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TransferData
